interface OfferModalProps {
  isOpen: boolean
  onClose: () => void
}

function OfferModal({ isOpen, onClose }: OfferModalProps) {
  if (!isOpen) return null

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4 py-8 overflow-y-auto"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-none max-w-4xl w-full max-h-[90vh] overflow-y-auto relative shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b-2 border-black px-6 sm:px-10 py-6 flex justify-between items-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-black uppercase">Публичная Оферта</h2>
          <button
            onClick={onClose}
            className="text-4xl font-bold text-black hover:text-[#F45B3C] transition-colors leading-none"
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>

        <div className="px-6 sm:px-10 py-8 text-black space-y-6">
          <p className="text-center text-lg font-semibold text-[#1E2B3C]">(по продукту «Планер намерений»)</p>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">1. Общие положения</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>1.1.</strong> Настоящий документ является официальным предложением (публичной офертой) владельца сайта www.planer-intent.ru (далее — «Оператор», «Мы») заключить с любым пользователем (далее — «Покупатель», «Пользователь») договор оказания цифрового продукта «Планер намерений» на условиях, изложенных в настоящем документе.
            </p>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>1.2.</strong> Использование, оплата и получение доступа к Планеру намерений означает безоговорочное принятие всех условий настоящей Оферты.
            </p>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>1.3.</strong> Настоящая Оферта действует до её отзыва Оператором.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">2. Предмет Оферты</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>2.1.</strong> Оператор предоставляет Пользователю доступ к цифровому продукту «Планер намерений» (далее — Продукт) на условиях настоящей Оферты, а Пользователь обязуется оплатить и пользоваться Продуктом.
            </p>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>2.2.</strong> Доступ к Продукту предоставляется в цифровой форме после подтверждения оплаты и/или регистрации, если такая предусмотрена.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">3. Порядок оплаты и расчёты</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>3.1.</strong> Стоимость и способы оплаты указаны на сайте и/или страницах оформления заказа.
            </p>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>3.2.</strong> Оплата считается произведённой с момента зачисления денежных средств на расчётный счёт Оператора.
            </p>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>3.3.</strong> После оплаты Пользователь получает доступ к Продукту в электронном виде (например: ссылка на материал, доступ в личный кабинет или другое).
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">4. Акцепт Оферты</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>4.1.</strong> Акцептом (принятием) условий настоящей Оферты считается: – оформление и подтверждение заказа на сайте, – оплата Продукта, – и/или любое другое действие, однозначно свидетельствующее о согласии Пользователя с условиями Оферты.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">5. Возврат и отказ от Продукта</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              Возврат и отказ от цифрового товара надлежащего качества не производится, в силу п. 14 Постановления Правительства РФ от 19.01.1998 № 55 издания, воспроизводимые на технических носителях, не подлежат возврату или обмену на аналогичный товар.
            </p>
          </section>

          <section>
            <h3 className="text-xl font-bold mb-3 text-black">6. Прочие условия</h3>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>6.1.</strong> Оператор вправе вносить изменения в условия Оферты без предварительного уведомления.
            </p>
            <p className="mb-2 text-gray-800 leading-relaxed">
              <strong>6.2.</strong> Споры разрешаются в соответствии с законодательством РФ.
            </p>
          </section>
        </div>

        <div className="sticky bottom-0 bg-white border-t-2 border-black px-6 sm:px-10 py-6">
          <button
            onClick={onClose}
            className="w-full bg-black text-white py-4 text-lg font-bold uppercase hover:bg-[#1E2B3C] transition-colors"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  )
}

export default OfferModal
